import React from 'react';
import './bootcamp.css';
import DATAVISUALIZATION from '../../../../img/bootcamp/DATAVISUALIZATION.png'
import DATAWRANGLING from '../../../../img/bootcamp/DATAWRANGLING.png'
import DEEPLEARNING from '../../../../img/bootcamp/DEEPLEARNING.png'
import FRAMEWORKS from '../../../../img/bootcamp/FRAMEWORKS.png'
import MACHINELEARNING from '../../../../img/bootcamp/MACHINELEARNING.png'
import NLP from '../../../../img/bootcamp/NLP.png'
import PROGRAMMING from '../../../../img/bootcamp/PROGRAMMING.png'
import TOOLS from '../../../../img/bootcamp/TOOLS.png'

const b_wywl = () => {
    const state = {
        wywl_item: [
            {
                img: PROGRAMMING,
                title: `PROGRAMMING`,
                desc: `Python,  R, Jupyter Notebooks, Julia`,
            },
            {
                img: DATAWRANGLING,
                title: `DATA WRANGLING`,
                desc: `SQL, Spark, Pandas, Tableau`,
            },
            {
                img: MACHINELEARNING,
                title: `MACHINE LEARNING`,
                desc: `Supervised, Unsupervised, & Reinforcement ML`,
            },
            {
                img: DEEPLEARNING,
                title: `DEEP LEARNING`,
                desc: `Neural Networks, GANS, CNN, LSTM`,
            },
            {
                img: NLP,
                title: `NLP`,
                desc: `Transformers, BERT, Sentiment Analysis`,
            },
            {
                img: FRAMEWORKS,
                title: `FRAMEWORKS`,
                desc: `Pytorch, Tensorflow, Keras, scikit-learn`,
            },
            {
                img: TOOLS,
                title: `TOOLS`,
                desc: `Airflow, MLFlow, MLOPs, Spark, Kubeflow`,
            },
            {
                img: DATAVISUALIZATION,
                title: `DATA VISUALIZATION`,
                desc: `D3.JS, Plotly, MatPlotLib, Tableau`,
            },
      ],
    };

    const renderWYWL = (item, i) => {
        return (
            <div className="b_why--block">
                <img className="b_why--img" src={item.img} alt="" />
                <div className='b_why--text_block'>
                    <h4 className="b_why--title_text">{item.title}</h4>
                    <p className="b_why--desc">{item.desc}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">What You’ll Learn</h3>
                <p className='b_why--undertitle'>ACCELERATE FROM ZERO TO MACHINE LEARNING</p>
                <div className="b_wywl_blocks">
                    {state.wywl_item.map((item, i) => renderWYWL(item, i))}
                </div>
            </div>
        </div>
    );
};

export default b_wywl;